import { Endpaper2Response, EndpaperRequest, EndpaperResponse } from '../../../../models/api/back/create-order/endpaper';
import {ResponseBase} from "../../../response-base";
import {AppThunk} from "../../../../app/store";
import {ordersDataActions} from "../../../../slices/orders/orders-data-slice";
import {apiActions} from "../../../../slices/api-slice";
import {ApiBaseBack} from "../../api-base-back";
import { ordersActions } from '../../../../slices/orders-slice';

export class ApiEndpaper2 extends ApiBaseBack<Endpaper2Response> {
  constructor(param: EndpaperRequest) {
    super(
      'GET',
      '/api/v1/additionalInfos2',
      'JSON',
      param,
    );
  }
}
